import React from 'react'
import './PaymentFailure.css'

const PaymentFailure = () => {
  return (
    <div>
      <h1>Payment failure Page</h1>
    </div>
  )
}

export default PaymentFailure
